<template>
  <section>
    <el-row class="total">
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-question sicon one"></i>
        <span class="tjContent">
          <div>点击人数</div>
          <div class="numText one">{{c2data.total.click_uv||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-success sicon two"></i>
        <span class="tjContent">
          <div>成功人数</div>
          <div class="numText two">{{c2data.total.clickok_uv||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-news sicon three"></i>
        <span class="tjContent">
          <div>跳出率</div>
          <div class="numText three">{{(100-c2data.total.clickok_per).toFixed(2)||'0'}}%</div>
        </span>
      </el-card>
      <!--<el-card class="box-card" shadow="hover">
        <i class="el-icon-tickets sicon four"></i>
        <span class="tjContent">
          <div>收入预估</div>
          <div class="numText four">{{c2data.total.income||'0'}}</div>
        </span>
      </el-card>-->
    </el-row>
    <el-row class="selectRow">
      <el-col style="min-width:600px" :span="14">
        <el-row :gutter="10">
          <el-button type="primary" id="seven" autofocus plain @click="changeDate(1)">昨天</el-button>
          <el-button type="primary" plain @click="changeDate(7)">最近7天</el-button>
          <el-date-picker
            v-model="dateVal"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="今天"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-row>
      </el-col>
      <el-col :span="10">
        <div style="float:right;min-width:150px">
          <el-row :gutter="10">
    <!--        <el-button type="primary" round @click="toogleChart">图表</el-button>-->
            <el-dropdown class="dropdown" @command="themeFilter">
              <el-button type="normal" class="dropdown">
                {{tText}}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" class="dropdown-menu">
                <el-dropdown-item command>所有类型</el-dropdown-item>
                <el-dropdown-item v-for="(v,i) in config" :key="i" :command="i">{{v[0]}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

             <el-input
              style="width:170px"
              @clear="getList"
              @keyup.enter.native="search"
              ref="input"
              class="search"
              v-model="pdata.issued_app_name "
              clearable
              placeholder="请输入发行游戏名称"
              :suffix-icon="pdata.issued_app_name .length>0?'':'el-icon-search'"
            ></el-input>
            
            <el-input
              style="width:170px"
              @clear="getList"
              @keyup.enter.native="search"
              ref="input"
              class="search"
              v-model="pdata.creative_name "
              clearable
              placeholder="请输入创意名称"
              :suffix-icon="pdata.creative_name .length>0?'':'el-icon-search'"
            ></el-input>
          </el-row>

          <!-- <el-button size="small" type="primary" @click="add">新增</el-button>
          <el-button size="small" type="info" @click="del">删除</el-button>
          <el-button size="small" type="success">启用</el-button>
          <el-button size="small" type="danger">禁用</el-button>-->
        </div>
      </el-col>
    </el-row>
    <!-- 统计文字 -->
    <!-- <el-row class="total">
      <el-col :span="4" :offset="4">点击人数:{{cdata.total.click_uv}}人</el-col>
      <el-col :span="4">成功人数:{{cdata.total.clickok_uv}} 人</el-col>
      <el-col :span="4">成功率:{{cdata.total.clickok_per}}%</el-col>
      <el-col :span="4">收入预估:{{cdata.total.income}}元</el-col>
    </el-row>-->
    <!-- 图表 -->
    <el-row style="min-width:1200px" v-show="!isChartShow">
      <div id="chart" style="width:100%; height:500px;"></div>
    </el-row>
    <!--列表-->
    <!--<el-table
      :data="cdata.list"
      style="width: 100%;min-width:1200px"
      stripe
      row-key="creative_id"
      @expand-change="expands"
      class="cdata"
    >
      <el-table-column type="expand" prop="name">
        <template slot-scope="s">
        
          <el-table :data="s.row.exData" :show-header="false" row-key="creative_id">
            <el-table-column prop="d_date" label="日期" align="center" width="100px"></el-table-column>
            <el-table-column prop="name" label="创意名称" align="left">
              <template slot-scope="scope">
                <span>{{scope.row.name}}{{scope.row.placement?'-'+scope.row.placement:''}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="type_name" label="创意类型" align="center"></el-table-column>
            <el-table-column prop="click_uv" label="点击人数" align="center"></el-table-column>
            <el-table-column prop="clickok_uv" label="成功人数" align="center"></el-table-column>
            <el-table-column prop="clickok_per" label="成功转化" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.clickok_per+'%'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="income" label="收入预估" align="center"></el-table-column>
            <el-table-column></el-table-column>
          </el-table>
         
        </template>
      </el-table-column>
      <el-table-column prop="creative_id" label="ID" width="100px" align="center"></el-table-column>
      <el-table-column prop="name" label="创意名称" align="left">
        <template slot-scope="scope">
          <span>{{scope.row.name}}{{scope.row.placement?'-'+scope.row.placement:''}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type_name" label="创意类型" align="center"></el-table-column>
      <el-table-column
        prop="click_uv"
        sortable
        :sort-method="(a,b)=>{return (a.click_uv-0)-(b.click_uv-0)}"
        label="点击人数"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="clickok_uv"
        sortable
        :sort-method="(a,b)=>{return (a.clickok_uv-0)-(b.clickok_uv-0)}"
        label="成功人数"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="clickok_per"
        sortable
        :sort-method="(a,b)=>{return (a.clickok_per-0)-(b.clickok_per-0)}"
        label="成功转化"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{scope.row.clickok_per+'%'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="income"
        label="收入预估"
        sortable
        :sort-method="(a,b)=>{return (a.income-0)-(b.income-0)}"
        align="center"
      ></el-table-column>
      <el-table-column label="广告位状态">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="$router.push({
          path: `/cDetail/${scope.row.creative_id}`,
        })"
          >更多</el-button>
        </template>
      </el-table-column>
    </el-table>-->
    
       <el-table
      :data="c2data.list"
      style="width: 100%;min-width:1200px"
      stripe
      row-key="creative_id"
      class="cdata"
    >
 
      <el-table-column prop="issued_app_id" label="ID" align="center"></el-table-column>
      <el-table-column prop="name" label="发行游戏名称"></el-table-column>
      <el-table-column prop="pname" label="发行游戏创意名称" width="180px" ></el-table-column>
      <el-table-column
        prop="click_uv"
        sortable
        :sort-method="(a,b)=>{return (a.click_uv-0)-(b.click_uv-0)}"
        label="创意点击数"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="clickok_uv"
        sortable
        :sort-method="(a,b)=>{return (a.clickok_uv-0)-(b.clickok_uv-0)}"
        label="创意点击确定数" width="180px" 
        align="center"
      ></el-table-column>
      <el-table-column
        prop="clickok_uv"
        label="创意点击率" width="180px" 
        align="center"
      >
      <template slot-scope="scope" >
      	<span v-if="scope.row.click_uv*100!=0">
      			{{(scope.row.clickok_uv/scope.row.click_uv*100).toFixed(2)+'%'}}
      	</span>
      	<span v-else>
      		--
      	</span>
      </template>     
     
      
      </el-table-column>
      
   <!--   <el-table-column prop="income" label="收入预估" align="center"></el-table-column>-->
      <el-table-column prop="jump_per"  label="跳出率" align="center">
      	<template slot-scope="scope">
      		{{scope.row.jump_per+'%'}}
        
        </template>
      	
      </el-table-column>
 <!--     <el-table-column prop="click_price" label="点击单价" align="center"></el-table-column>-->
      
      
      
      <!--<el-table-column label="广告位状态">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="$router.push({
          path: `/cDetail/${scope.row.issued_app_id}`,
        })"
          >更多</el-button>
        </template>
      </el-table-column>-->
    </el-table>

    <!--<div class="pageRow">
      <el-pagination
        class="pagination"
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page.sync="pdata.page"
        :page-sizes="[20, 40, 60, 80]"
        :page-size="pdata.perpage"
        background
        layout="sizes, prev, pager, next, jumper"
        :total="pdata.perpage*maxPage"
      ></el-pagination>
    </div>-->
    <el-dialog title="编辑创意组合" :visible.sync="editDialog">
      <el-form :model="group"></el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editDialog = false">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { scdata,sc2data3, cdataEx } from "../../api/api";
import echarts from "echarts";

export default {
  data() {
    return {
      isChartShow: true,
      chartColumn: null,
      timer: null,
      pdata: {
        page: 1,
        perpage: 20,
        type: "",
        kw: "",
        issued_app_name:"",
        creative_name:"",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
        // sdate: "2019-04-01",
        // edate: "2019-04-01",
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 }, //所有数据
      c2data: { total: {}, chat: {}, list: [], max_page: 1},
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["点击人数", "点击成功数", "点击率"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "点击人数",
            type: "line",
            smooth: true,
            data: []
          },
          {
            name: "点击成功数",
            type: "line",
            smooth: true,
            data: []
          },
          {
            name: "点击率",
            type: "line",
            smooth: true,
            data: []
          }
        ],
        color: [
          "#61c0a0",
          "#ee4f54",
          "#8ec1b0",
          "#a6e8ba",
          "#ceead4",
          "#f2e247",
          "#f6e98b",
          "#f77b31",
          "#fc9656",
          "#ec151a",
          "#ee4f54",
          "#ee2159",
          "#fbaaa6"
        ]
      }
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },
      deep: true
    }
  },
  methods: {
    getList() {
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
//    scdata(p, this.$cookie.getCookie("login")).then(res => {
//      if (res.code == 200) {
//        if (res.data.list.length > 0) {
//          res.data.list.forEach(x => {
//            x.exData = [];
//          });
//        }
//        this.cdata = res.data;
//        this.maxPage = res.data.max_page;
//        this.option.xAxis.data = res.data.chart.date;
//        this.option.series[0].data = res.data.chart.click_uv;
//        this.option.series[1].data = res.data.chart.clickok_uv;
//        this.option.series[2].data = res.data.chart.clickok_per;
//        this.drawColumnChart();
//      }
//    });
      
      sc2data3(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	
          this.c2data = res.data;
          this.maxPage = res.data.max_page;
//        this.option.xAxis.data = res.data.chart.date;
//        this.option.series[0].data = res.data.chart.click_uv;
//        this.option.series[1].data = res.data.chart.clickok_uv;
//        this.option.series[2].data = res.data.chart.clickok_per;
//        this.drawColumnChart();
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.ad_creative_type;
        this.tags = this.$store.config.product_tag;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    drawColumnChart() {
      this.chartColumn = echarts.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    themeFilter(s) {
      this.tText = s === "" ? "请选择创意类型" : this.config[s][0];
      this.pdata.type = s === "" ? "" : this.config[s][1];
      this.getList();
    },
    search() {
      // 有问题;
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
    toogleChart() {
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(() => {
        that.chartColumn.resize();
      }, 100);
    },
    sort(a, b) {
      return a.click_uv - 0 - (b.click_uv - 0);
    },
    expands(r, es) {
      var isshou = false;
      if (es.length > 0) {
        es.forEach(v => {
          if (v.creative_id == r.creative_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = `creative_id=${r.creative_id}&sdate=${this.dateVal[0]}&edate=${
          this.dateVal[1]
        }`;
        cdataEx(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            r.exData = res.data.list;
          }
        });
      }
    }
  },

  mounted() {
    this.getConfig();
    this.getList();
    document.getElementById("seven").focus();
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// cData3.vue?73327d05